import React from 'react'
import { Router, Route } from 'react-router-dom'

import DeviceSubtypeRouter from './screens/DeviceSubtypeRouter'
import Main from './screens/Main'
import Orders from './screens/Orders'
import TabsModeResolver from './containers/TabsModeResolver'
import OrderDetailsModal from './containers/tabs/OrderDetailsModal'
import TabOrderPayNowModal from './containers/tabs/TabOrderPayNowModal'
import TabMenu from './screens/tabs/TabMenu'
import ChangeCalculator from './screens/ChangeCalculator'
import RegisterDevice from './screens/RegisterDevice'
import Receipt from './screens/Receipt'
import RevenueCenterSetup from './screens/RevenueCenterSetup'
import ReviewCheck from './screens/tabs/ReviewCheck'
import RichCheckout from './screens/RichCheckout'
import Signature from './screens/Signature'
import DebugInfo from './components/DebugInfo'
import RichCheckoutPOS from './containers/richCheckout/Container'
import CartItemDetailsModal from './containers/CartItemDetailsModal'
import OrdersMenuSelection from './screens/OrdersMenuSelection'
import Tender from './screens/Tender'
import SelectDiscount from './containers/SelectDiscount'

import DeviceLogin from './containers/DeviceLogin'
import UserLogin from './containers/UserLogin'
import BridgeHandler from './containers/BridgeHandler'
import AttendantSummary from './containers/AttendantSummary'
import SelectNoOpPayment from './containers/SelectNoOpPayment'
import Hooks from './components/Hooks'

import KioskApp from './kiosk/App'

import { customHistory } from './stores'

const App = () => {
  return (
    <>
      <Router history={customHistory}>
        <Route path="/" exact component={DeviceSubtypeRouter} />
        <Route path="/" component={BridgeHandler} />
        <Route path="/" component={DeviceLogin} />
        <Route path="/" component={Hooks} />

        <Route path="/concession-order" component={Main} />
        <Route path="/concession-order/cart/:cartItemIndex?" exact component={CartItemDetailsModal} />

        <Route path="/orders" exact component={Orders} />
        <Route path="/orders/menuSelection" exact component={OrdersMenuSelection} />
        <Route path="/tabs" component={TabsModeResolver} />
        <Route path="/tabs/:orderId" component={OrderDetailsModal} />
        <Route path="/tabs/attendant/summary-report" exact component={AttendantSummary} />
        <Route path="/tender/:orderId/:paymentId?" exact component={Tender} />
        <Route path="/tab-order/:orderId?" component={TabMenu} />
        <Route path="/tab-order/:orderId?/pay-now" exact component={TabOrderPayNowModal} />
        <Route path="/tab-order/:orderId?/cart/:cartItemIndex?" exact component={CartItemDetailsModal} />
        <Route path="/tab-order/:modalType?/select-payment" component={SelectNoOpPayment} />
        <Route path="/tab-order/pay-now/select-discount" component={SelectDiscount} />

        <Route path="/change-calculator/:orderId?" exact component={ChangeCalculator} />
        <Route path="/receipt/:orderUuid?/:paymentId?" exact component={Receipt} />
        <Route path="/review-check/:orderUuid/:paymentId?" component={ReviewCheck} />
        <Route path="/signature/:orderUuid/:paymentId?" component={Signature} />
        <Route path="/pos-rich-checkout" exact component={RichCheckoutPOS} />
        <Route path="/rich-checkout/:orderId?" exact component={RichCheckout} />

        <Route path="/register-device" exact component={RegisterDevice} />
        <Route path="/revenue-center-setup" exact component={RevenueCenterSetup} />
        <Route path="/device-login" component={DeviceLogin} />
        <Route path="/user-login" component={UserLogin} />
        <Route path="/debug-info" component={DebugInfo} />

        <Route path="/kiosk" component={KioskApp} />
      </Router>
    </>
  )
}

export default App
